/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'wwg-array-fields',
  templateUrl: './array-fields.component.html',
  styleUrls: ['./array-fields.component.scss']
})
export class ArrayFieldsComponent {

  @Input() public maxFields = 30;
  @Input() public title = 'Custom fields';
  @Input() public create: () => object;
  _model: object[] = [];

  @Input() get model() {
    return this._model;
  }
  @Output() modelChange = new EventEmitter();

  constructor(
    private notificationService: NotificationService
  ) { }

  set model(val) {
    this._model = val || [];
    this.modelChange.emit(this._model);
  }

  public addField() {
    if (this.model.length < this.maxFields) {
      this.model.push(this.create());
    } else {
      this.notificationService.open('Max ' + this.maxFields + ' fields allowed.');
    }
  }

  private removeField(index) {
    this.model.splice(index, 1);
  }

  private getFields() {
    return this.model;
  }

  private displayFields(fields: object[]) {
    if (Array.isArray(fields)) {
      this.model = fields;
    }
  }
}
